<template>
  <div class="flex-1 overflow-y-auto scrollbar-light dark:scrollbar-dark p-3">
    <surface-editor-core-panel-section-heading>Basic Shapes</surface-editor-core-panel-section-heading>

    <div class="grid grid-cols-2 gap-3">
      <button
        v-for="shape in shapes"
        :key="shape.id"
        class="aspect-[1/1] flex items-center justify-center border border-gray-200 dark:border-charcoal-600 rounded-md p-3 hover:bg-gray-100 dark:hover:bg-charcoal-700 hover:border-gray-300 dark:hover:border-charcoal-500 transition-colors"
        draggable="true"
        @dragstart="event => onDragStart(event, shape)"
        @dragend="onDragEnd"
        @click="createShape(shape)"
      >
        <u-icon :name="shape.icon" class="text-6xl text-gray-500 dark:text-gray-300" />
      </button>
    </div>
  </div>
</template>

<script setup>
  import {storeToRefs} from 'pinia';

  const surfaceEditorStore = useSurfaceEditorStore();
  const {activeSurface} = storeToRefs(surfaceEditorStore);
  const {setDragPayload, clearDragPayload} = useSurfaceEditorDragState();

  const {getShapePresets, buildShapeElement} = useSurfaceEditorElementFactory();

  const shapes = computed(() => getShapePresets(activeSurface.value));

  function onDragStart(event, shape) {
    const dataTransfer = event.dataTransfer;

    if (!dataTransfer) {
      return;
    }

    const payload = {
      type: 'shape',
      id: shape.id
    };

    dataTransfer.setData('application/json', JSON.stringify(payload));
    dataTransfer.setData('text/plain', shape.id);
    dataTransfer.effectAllowed = 'copy';
    setDragPayload(payload);
  }

  function onDragEnd() {
    clearDragPayload();
  }

  function createShape(shape) {
    const element = buildShapeElement({preset: shape});

    if (!element) {
      return;
    }

    surfaceEditorStore.addElement({element, surface: activeSurface.value});
  }


</script>
